var data = {
	"body": "<g fill=\"none\"><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"4\" stroke=\"currentColor\" stroke-width=\"2\"/></g>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
